// Redux
import { connect } from 'react-redux';
import { withRouter } from "react-router";

// Components
import Multimidia from '../components/Multimidia/Multimidia';

function mapStateToProps(state, ownProps) {
	return {
		project: ownProps.params.project
	};
}

function mapDispatchToProps(dispatch) {
	return { 
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Multimidia));


// WEBPACK FOOTER //
// ./src/containers/MultimidiaContainer.js